import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(pages)/layout.tsx");
